import { render, staticRenderFns } from "./PreSortROITable.vue?vue&type=template&id=0d085ddc&scoped=true&"
import script from "./PreSortROITable.vue?vue&type=script&lang=js&"
export * from "./PreSortROITable.vue?vue&type=script&lang=js&"
import style0 from "./PreSortROITable.vue?vue&type=style&index=0&id=0d085ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d085ddc",
  null
  
)

export default component.exports